var map = {
	"./Error404.vue": [
		"e51e",
		"Error404-vue"
	],
	"./PressRelease.vue": [
		"7da1",
		"PressRelease-vue"
	],
	"./Root.vue": [
		"e11f"
	],
	"./RouterWrapperPage.vue": [
		"9a6e"
	],
	"./Stories.vue": [
		"faa1",
		"Stories-vue"
	],
	"./StoryFull.vue": [
		"010b",
		"StoryFull-vue"
	],
	"./Terms.vue": [
		"c821",
		"Terms-vue"
	],
	"./UserActivation.vue": [
		"25b0",
		"UserActivation-vue"
	],
	"./UserPasswordReset.vue": [
		"f274",
		"UserPasswordReset-vue"
	],
	"./Wrapper.vue": [
		"2f2e"
	],
	"./_redirect/FirstNewsroomEdit.vue": [
		"1c29",
		"_redirect-FirstNewsroomEdit-vue"
	],
	"./auth/Auth.vue": [
		"fa72",
		"auth-Auth-vue"
	],
	"./auth/ForgottenPassword.vue": [
		"3258",
		"auth-ForgottenPassword-vue"
	],
	"./auth/Login.vue": [
		"b2c5",
		"auth-Login-vue"
	],
	"./dashboard/Dashboard.vue": [
		"56c3",
		"dashboard-Dashboard-vue"
	],
	"./dashboard/DashboardAlerts.vue": [
		"7ecf",
		"dashboard-DashboardAlerts-vue"
	],
	"./dashboard/DashboardSuggestedNewsrooms.vue": [
		"fc5d",
		"dashboard-DashboardSuggestedNewsrooms-vue"
	],
	"./dashboard/DashboardSuggestedStories.vue": [
		"989c",
		"dashboard-DashboardSuggestedStories-vue"
	],
	"./embedded/EmbeddedNewsroom.vue": [
		"73ba",
		"embedded-EmbeddedNewsroom-vue"
	],
	"./embedded/EmbeddedNewsroomStories.vue": [
		"e324",
		"embedded-EmbeddedNewsroomStories-vue"
	],
	"./embedded/EmbeddedStory.vue": [
		"6ac7",
		"embedded-EmbeddedStory-vue"
	],
	"./embedded/Index.vue": [
		"8dea",
		"embedded-Index-vue"
	],
	"./newsroom/Newsroom.vue": [
		"bb69",
		"newsroom-Newsroom-vue"
	],
	"./newsroom/NewsroomAbout.vue": [
		"8707",
		"newsroom-NewsroomAbout-vue~newsroomEdit-NewsroomEditAbout-vue",
		"newsroom-NewsroomAbout-vue"
	],
	"./newsroom/NewsroomAssets.vue": [
		"bb3b",
		"newsroom-NewsroomAssets-vue"
	],
	"./newsroom/NewsroomStories.vue": [
		"2c9b",
		"newsroom-NewsroomStories-vue"
	],
	"./newsroomEdit/NewsroomEdit.vue": [
		"a9f5",
		"DashboardSettingsModal~newsroomEdit-NewsroomEdit-vue",
		"newsroomEdit-NewsroomEdit-vue"
	],
	"./newsroomEdit/NewsroomEditAbout.vue": [
		"e722",
		"newsroom-NewsroomAbout-vue~newsroomEdit-NewsroomEditAbout-vue",
		"newsroomEdit-NewsroomEditAbout-vue"
	],
	"./newsroomEdit/NewsroomEditAssets.vue": [
		"e55c",
		"newsroomEdit-NewsroomEditAssets-vue"
	],
	"./newsroomEdit/NewsroomEditStories.vue": [
		"71d3",
		"newsroomEdit-NewsroomEditStories-vue"
	],
	"./registrations/FreeNewsroomLanding2.vue": [
		"055c",
		"registrations-FreeNewsroomLanding2-vue~registrations-JournalistRegister-vue",
		"registrations-FreeNewsroomLanding2-vue"
	],
	"./registrations/JournalistRegister.vue": [
		"97f9",
		"registrations-FreeNewsroomLanding2-vue~registrations-JournalistRegister-vue",
		"registrations-JournalistRegister-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;